const RFC_RE = /^([A-ZÑ&]{3,4})\d{6}[A-Z0-9]{3}$/i;
const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
const PHONE_RE = /^[+()\-\s\d]{7,20}$/;
const ZIP_RE = /^\d{5}$/;

export const isValidRFC = (v) => (!v ? true : RFC_RE.test(v.trim().toUpperCase()));
export const isValidEmail = (v) => (!v ? true : EMAIL_RE.test(v.trim()));
export const isValidPhone = (v) => (!v ? true : PHONE_RE.test(v));
export const isValidZip = (v) => (!v ? true : ZIP_RE.test(v));

export function clientErrors(client) {
  const errs = {};
  if (!client.name || client.name.trim().length < 2)
    errs.name = "Nombre requerido (mínimo 2 caracteres)";
  if (!isValidRFC(client.rfc)) errs.rfc = "Formato de RFC inválido (ej: XAXX010101000)";
  if (!isValidEmail(client.email)) errs.email = "Email inválido";
  if (!isValidPhone(client.phone)) errs.phone = "Teléfono inválido";
  if (!isValidZip(client.zip)) errs.zip = "CP debe ser de 5 dígitos";
  return errs;
}
